import { MoonIcon, SunIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";

import { useTheme } from "~/providers/ThemeProvider";
import { Bars3Icon } from "~/ui";

export interface NavBarProps {
  setSidebarOpen?: (v: boolean) => void;
}

export const NavBar = ({ setSidebarOpen }: NavBarProps) => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="sticky top-0 z-10 flex h-16 shrink-0 items-center justify-between px-4 xl:hidden">
      <div className="flex items-center">
        {setSidebarOpen && (
          <button
            type="button"
            className="m-2.5 rounded-md p-2.5 text-secondary-20 hover:bg-surface-container-highest dark:text-primary"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">{t("layout.open_sidebar")}</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        )}
      </div>
      <button
        type="button"
        className="rounded-md p-2 text-secondary-20 hover:bg-surface-container-highest dark:text-primary"
        onClick={toggleTheme}
        aria-label={
          theme === "dark" ? "Switch to light mode" : "Switch to dark mode"
        }
      >
        {theme === "dark" ? (
          <SunIcon className="h-6 w-6" aria-hidden="true" />
        ) : (
          <MoonIcon className="h-6 w-6" aria-hidden="true" />
        )}
      </button>
    </div>
  );
};
